import { render, staticRenderFns } from "./wave.vue?vue&type=template&id=2602c29c&scoped=true&"
import script from "./wave.vue?vue&type=script&lang=js&"
export * from "./wave.vue?vue&type=script&lang=js&"
import style0 from "./wave.vue?vue&type=style&index=0&id=2602c29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2602c29c",
  null
  
)

export default component.exports